module.exports = __webpack_public_path__ + "static/media/original_blockchain_system_p.e05e92b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/original_blockchain_system_p.jpg
// module id = 361
// module chunks = 0